import { RouteConstants } from '@/features/router/RouteConstants';
import { matchPath } from 'react-router-dom';

export const SMS_CAMPAIGNS_PATTERNS = [
  RouteConstants.smsCampaigns,
  RouteConstants.createCampaignSms,
  RouteConstants.editCampaignSms,
  RouteConstants.smsCampaignDetails,
];

export const SMS_TEMPLATES_PATTERNS = [
  RouteConstants.smsTemplates,
  RouteConstants.createSmsTemplate,
  RouteConstants.editSmsTemplate,
  RouteConstants.smsTemplateDetails,
  RouteConstants.smsTemplatesEditHub,
  RouteConstants.smsTemplatesDeleteHub,
];

export const SMS_TEMPLATE_MUTATION_PATTERNS = [
  RouteConstants.createSmsTemplate,
  RouteConstants.smsTemplatesEditHub,
  RouteConstants.smsTemplatesDeleteHub,
];

export const SMS_SENDERS_PATTERNS = [
  RouteConstants.smsSenders,
  RouteConstants.createSmsSender,
  RouteConstants.editSmsSender,
  RouteConstants.smsSenderDetails,
];

export const SMS_SENDER_MUTATION_PATTERNS = [RouteConstants.createSmsSender, RouteConstants.editSmsSender];

export const SMS_PACKAGES_PATTERNS = [RouteConstants.smsPackages];

export const isSmsSenderRoute = (pathname: string) =>
  SMS_SENDERS_PATTERNS.some((pattern) => matchPath(pathname, { path: pattern, exact: true }));
